<template>
  <div v-loading="loading">
    <div class="header">
      <el-input
        v-model="search"
        style="width: 250px; margin-right: 10px; height:33px"
        placeholder="Izlash"
        clearable
        @clear="onSearch"
      >
        <template #append>
          <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt="" />
          </el-button>
        </template>
      </el-input>
      <el-select
        v-model="category_id"
        placeholder="Kategoriya"
        @change="getCategories()"
      >
        <el-option
          v-for="category in categories"
          :value="category.id"
          :key="category.title"
          :label="category.title"
        />
      </el-select>
      <el-upload
        v-model:file-list="fileList"
        class="upload-demo"
        :action="url + 'api/v1/products/sync-excel'"
        :headers="uploadHeader"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="1"
        :on-success="handleSucces"
        :on-error="handleFail"
        :on-exceed="handleExceed"
      >
        <el-button type="primary">Excell yuklash</el-button>
      </el-upload>
      <el-button type="primary" @click="getExcell()">Excell olish</el-button>
      <el-button type="primary" @click="$router.push({ name: 'ProductsAdd' })"
        >Qo'shish</el-button
      >
    </div>
    <el-table
      class="table-body"
      :data="tableData"
      border
      height="calc(100vh - 250px)"
    >
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="category" label="Kategoriya" />
      <el-table-column prop="title" label="Nomi" />
      <el-table-column prop="price" label="Narxi" />
      <el-table-column prop="max_available" label="Soni" />
      <el-table-column prop="unit_of_measure" label="O'chov birligi" />
      <el-table-column align="center">
        <template #default="scope">
          <el-button
            size="small"
            type="danger"
            @click="deleteBudgetParam(scope.row.id)"
            >O'chirish
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="
              $router.push({
                name: 'ProductsEdit',
                params: { id: scope.row.id },
              })
            "
            >Tahrirlash
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import http from "@/http";
export default {
  name: "ProductsList",
  data() {
    return {
      loading: false,
      tableData: [],
      categories: [],
      category_id: "",
      search: "",
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      url: process.env.VUE_APP_BASE_API_URL,
    };
  },
  computed: {
    uploadHeader() {
      return {
        Authorization: this.$store.state.accessToken,
      };
    },
  },
  methods: {
    onSearch() {
      this.getProducts();
    },
    getExcell() {
      this.loading = true;
      http
        .get("api/v1/products/excel", { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "tovarlar.xlsx"); // or dynamically set the filename
          document.body.appendChild(link);
          link.click();
          link.remove();
          ElMessage({
            type: "success",
            message: "Muvaffaqqiyatli yuklandi",
          });
        })
        .catch(({ response }) => {
          ElNotification.error({
            message: response.data.message || "Xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategories() {
      http.get("api/v1/product-categories").then((res) => {
        this.categories = res.data.product_categories;
        this.getProducts();
      });
    },
    handleSucces() {
      this.getProducts();
      ElMessage({
        type: "success",
        message: "Muvaffaqqiyatli yuklandi",
      });
    },
    handleFail() {
      ElNotification({
        type: "error",
        title: "Xatolik",
        message: "Iltimos, qayta urinib ko'ring",
      });
    },
    getProducts() {
      this.loading = true;
      this.$http
        .get(
          `api/v1/products?category_id=${this.category_id}&search=${this.search}`
        )
        .then(({ data }) => {
          this.tableData = data.products;
          this.tableData.forEach((product) => {
            if (product.unit_of_measure === "collection") {
              product.unit_of_measure = "To'plam";
            }
            if (product.unit_of_measure === "piece") {
              product.unit_of_measure = "Dona";
            }
            if (product.unit_of_measure === "package") {
              product.unit_of_measure = "Quti";
            }
          });
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteBudgetParam(id) {
      ElMessageBox.confirm("Parametrni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/products/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getProducts();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
  },
  mounted() {
    this.getProducts();

    http.get("api/v1/product-categories").then((res) => {
      this.categories = res.data.product_categories;
    });
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 20px;
  .filter {
    display: flex;
    justify-content: flex-start;
  }
}
.table-body {
  img {
    width: 80px;
  }
}
</style>
